export const tickerWidth = {flexBasis: "auto", width: 80};
export const orgNameWidth = {flexBasis: "auto", width: 155};
export const openIdeasWidth = {flexBasis: "auto", width: 125};
export const latestActivityWidth = {flexBasis: "auto", width: 60};
export const sentimentTodayValueWidth = {flexBasis: "auto", width: 80};
export const sentimentOneDayChangeWidth = {flexBasis: "auto", width: 85};
export const priceChangeTodayChangeWidth = {flexBasis: "auto", width: 90};
export const earningsWidth = {flexBasis: "auto", width: 90};